var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"grid"}},[_c('admin-booking-list',{attrs:{"bookings":_vm.bookings,"season":_vm.season,"search-query":_vm.searchQuery,"totals":_vm.totals}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }